module.exports = "/img/404_cloud.0f4bc32b.png";